import {Directive, HostBinding, Input} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[reactiveElement]',
})
export class ReactiveElementDirective {
  constructor() {}

  @Input() mobileSize = 12;
  @Input() desktopSize: number;
  @Input() ipadSize: number;
  @Input() desktopLargeSize: number;
  @Input() desktopXLSize: number;

  @HostBinding('class') get classe() {
    return [
      this.getMobileSizeClass(),
      this.getIPadSizeClass(),
      this.getDesktopSizeClass(),
      this.getDesktopLargeClass(),
      this.getDesktopXLClass(),
    ].join(' ');
  }

  private getMobileSizeClass() {
    return `grid_col-sm-${this.mobileSize}`;
  }

  private getDesktopSizeClass() {
    if (this.desktopSize != null) {
      return `grid_col-${this.desktopSize}`;
    } else {
      return '';
    }
  }

  private getIPadSizeClass() {
    if (this.ipadSize != null) {
      return `grid_col-md-${this.ipadSize}`;
    } else {
      return '';
    }
  }

  private getDesktopLargeClass() {
    if (this.desktopLargeSize != null) {
      return `grid_col-lg-${this.desktopLargeSize}`;
    } else {
      return '';
    }
  }

  private getDesktopXLClass() {
    if (this.desktopXLSize != null) {
      return `grid_col-xl-${this.desktopXLSize}`;
    } else {
      return '';
    }
  }
}
